module.exports = __webpack_public_path__ + "img/1.58af703c.png";